
	import {
		defineComponent,
		onMounted,
		ref
	} from 'vue';
	import {
		ReloadOutlined,
		PlusOutlined
	} from '@ant-design/icons-vue';
	import addActivity from "./addActivity.vue"
	export default defineComponent({
		components: {
			ReloadOutlined,
			PlusOutlined,
			addActivity
		},
		props: {

		},
		setup(props, context) {
			// 声明
			let searchName = ref("")
			const openPop = ref();
			let value = ref(undefined)
			let time = ref("")


			// 页面渲染时加载
			onMounted(() => {

			})
			// 搜索查询
			const onSearch = () => {

				let searchData = {
					searchValue:searchName.value,
					time:time.value
				}
				context.emit("search", searchData);
				// console.log('or use this.value', searchName.value);
			};
			// 刷新
			const refresh = () => {
				context.emit("refresh", "ok");
			}

			// 选择 确认时间
			const onChangeTime = (value, dateString) => {
				console.log('onOk: ', value);
				time.value = dateString
				let searchData = {
					searchValue:searchName.value,
					time:time.value
				}
				context.emit("search", searchData);
			};
			// 创建活动
			const add = () => {
				openPop.value.open();
			}



			return {
				refresh,
				value,
				searchName,
				onSearch,
				openPop,
				add,
				onChangeTime,
				time,
			};
		},

	});
